import { readAllData, STORES } from "utility"
import { mergeUpsertOffline } from "./crud"
import dayjs from "dayjs"

export async function getExpensesOffline({ page = 1, limit = 20, filters = {} }) {
  let data = await readAllData(STORES.EXPENSES)

  // Tri par date décroissante (comme le backend : creationDate desc)
  data.sort((a, b) => {
    const da = new Date(a.creationDate || a.date || 0)
    const db = new Date(b.creationDate || b.date || 0)
    return db - da
  })

  // 🔍 Filtre par type de dépense (contains, insensible à la casse)
  if (filters.expensesType) {
    const search = filters.expensesType.toLowerCase()
    data = data.filter((e) =>
      (e.expensesType || "").toLowerCase().includes(search),
    )
  }

  // 🔍 Filtre par fournisseur
  if (filters.providerName) {
    const search = filters.providerName.toLowerCase()
    data = data.filter((e) =>
      (e.providerName || "").toLowerCase().includes(search),
    )
  }

  // 📅 Filtre dates
  const getDate = (e) => e.date || e.creationDate
  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day")
    data = data.filter((e) => {
      const d = getDate(e)
      return d && dayjs(d).valueOf() >= start.valueOf()
    })
  }
  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day")
    data = data.filter((e) => {
      const d = getDate(e)
      return d && dayjs(d).valueOf() <= end.valueOf()
    })
  }

  const totalItems = data.length
  const startIdx = (page - 1) * limit
  return { data: data.slice(startIdx, startIdx + limit), totalItems }
}

export async function createExpenseOffline(body) {
  const tempId = crypto.randomUUID()
  const expense = {
    ...body,
    id: tempId,
    creationDate: new Date().toISOString(),
    __offline: true,
  }
  await mergeUpsertOffline(STORES.EXPENSES, expense, { markOffline: true })
  return expense
}
